import WIDGETS from './widgets';

export default {
	name: 'ticket_questionnaire',
	spacing: 2,
	widgets: [{ content: WIDGETS.TICKET_QUESTIONNAIRE, breakpoints: { xs: 12, sm: 12 }, lazy_loading: 0 }],
};
